import { User } from '../models';
import { HasId } from '../interfaces';

export class UserNote {
    user: User;
    userID: number;
    note: Note;
    noteID: number;
}

export class Note implements HasId {
    public id: number;
    public subject: string;
    public created: Date;
    public content: string;
    public userNotes: UserNote[];
    public userID: number;
}


// WEBPACK FOOTER //
// ./src/models/Note.tsx